<template>
  <div class="tournament-content-tab tab-fights" v-bind:class="{'tournament-content-active-tab':activeTab == 14}">

    <!-- Шапка -->
    <section class="adm-panel adm-head">
      <h3 class="adm-title">
        <tkd-icon name="kyorugi"/> Поєдинки по відділеннях
        <span class="adm-count">{{ totals.done }}/{{ totals.all }}</span>
      </h3>
      <div class="fg-head-tools">
        <div class="adm-segmented" role="tablist" aria-label="Які поєдинки показувати">
          <button type="button" v-for="f in filters" :key="f.key" role="tab"
                  :aria-selected="filter === f.key ? 'true' : 'false'"
                  :class="{ active: filter === f.key }" @click="filter = f.key">{{ f.label }}</button>
        </div>
        <input type="search" class="adm-input fg-search" v-model="search" placeholder="Пошук: ПІБ, категорія, №" aria-label="Пошук поєдинку">
      </div>
    </section>

    <div class="adm-empty" v-if="!lanes.length">
      <div class="adm-empty-icon" aria-hidden="true"><tkd-icon name="section"/></div>
      <p>Немає поєдинків для показу</p>
      <span class="fg-hint">Розподіліть категорії по відділеннях і пронумеруйте поєдинки на вкладці «Нумерація».</span>
    </div>

    <!-- Колонки: відділення -->
    <div class="fg-lanes" v-else>
      <section class="fg-lane" v-for="lane in lanes" :key="lane.key">
        <header class="fg-lane-head">
          <div class="fg-lane-title">
            <span class="fg-lane-name">{{ lane.name }}</span>
            <span class="fg-lane-start" v-if="lane.start">з № {{ lane.start }}</span>
          </div>
          <div class="fg-lane-progress">
            <span>{{ lane.done }}/{{ lane.total }}</span>
            <span class="fg-bar" aria-hidden="true"><span :style="{ width: (lane.total ? Math.round(lane.done / lane.total * 100) : 0) + '%' }"></span></span>
          </div>
          <div class="fg-lane-next" v-if="lane.next">
            Далі: <b>№ {{ lane.next.number || '—' }}</b> · {{ lane.next.categoryName }}
          </div>
        </header>

        <ol class="fg-list" v-if="lane.visible.length">
          <li v-for="f in lane.visible" :key="f.key" class="fg-fight" :class="{ 'is-done': f.winnerId, 'is-next': lane.next && lane.next.key === f.key, 'is-list': f.isList }">
            <!-- пумсе / список — одним рядком -->
            <template v-if="f.isList">
              <div class="fg-fight-top">
                <span class="fg-num">—</span>
                <router-link class="fg-cat" :to="categoryLink(f.categoryId)">{{ f.categoryName }}</router-link>
              </div>
              <div class="fg-list-note"><tkd-icon name="poomsae"/> Пумсе / список · {{ f.count }} учасн.</div>
            </template>

            <template v-else>
              <div class="fg-fight-top">
                <span class="fg-num" :title="f.number ? 'Номер поєдинку' : 'Ще не пронумеровано'">{{ f.number ? '№ ' + f.number : 'б/н' }}</span>
                <router-link class="fg-cat" :to="categoryLink(f.categoryId)">{{ f.categoryName }}</router-link>
                <span class="adm-chip fg-round">{{ f.round }}</span>
              </div>

              <div class="fg-side blue" :class="{ win: f.winnerId && f.winnerId === f.blue.id, lose: f.winnerId && f.blue.id && f.winnerId !== f.blue.id }">
                <span class="fg-corner" aria-hidden="true"></span>
                <span class="fg-name">
                  <template v-if="f.blue.id">{{ f.blue.name }}<small v-if="f.blue.club">{{ f.blue.club }}</small></template>
                  <em v-else>{{ f.blue.placeholder }}</em>
                </span>
                <span class="fg-points" v-if="hasValue(f.blue.points)">{{ f.blue.points }}</span>
                <span class="fg-win-mark" v-if="f.winnerId && f.winnerId === f.blue.id" title="Переможець"><tkd-icon name="check"/></span>
              </div>
              <div class="fg-side red" :class="{ win: f.winnerId && f.winnerId === f.red.id, lose: f.winnerId && f.red.id && f.winnerId !== f.red.id }">
                <span class="fg-corner" aria-hidden="true"></span>
                <span class="fg-name">
                  <template v-if="f.red.id">{{ f.red.name }}<small v-if="f.red.club">{{ f.red.club }}</small></template>
                  <em v-else>{{ f.red.placeholder }}</em>
                </span>
                <span class="fg-points" v-if="hasValue(f.red.points)">{{ f.red.points }}</span>
                <span class="fg-win-mark" v-if="f.winnerId && f.winnerId === f.red.id" title="Переможець"><tkd-icon name="check"/></span>
              </div>

              <div class="fg-decision" v-if="f.decision"><span class="adm-chip strong">{{ f.decision }}</span></div>
            </template>
          </li>
        </ol>
        <p class="fg-empty" v-else>{{ lane.total ? 'Нічого не знайдено' : 'Поєдинків немає' }}</p>
      </section>
    </div>
  </div>
</template>

<script>
  import 'src/assets/css/tkd-theme.css';
  import 'src/assets/css/tkd-admin.css';

  const ROUND_LABELS = {1: 'Фінал', 2: 'Півфінал', 3: '1/4', 4: '1/8', 5: '1/16', 6: '1/32'};

  export default {
    name: "tab-fights",
    data() {
      return {
        filter: 'all',
        search: '',
        filters: [
          {key: 'all', label: 'Усі'},
          {key: 'pending', label: 'Не проведені'},
          {key: 'done', label: 'Проведені'},
        ],
      }
    },
    computed: {
      activeTab() {
        return this.$store.getters['settings/activeTournamentTab'];
      },
      tournamentOne() {
        return this.$store.getters['tournament/tournamentOne'];
      },
      item() {
        return this.tournamentOne && this.tournamentOne.data && this.tournamentOne.data.item ? this.tournamentOne.data.item : null;
      },
      protocols() {
        return this.item && Array.isArray(this.item.protocols) ? this.item.protocols : [];
      },
      sections() {
        return this.item && Array.isArray(this.item.sections) ? this.item.sections : [];
      },
      // колонки: відділення за назвою ("Татамі 2" перед "Татамі 10") + "Без відділення", якщо там є поєдинки
      lanes() {
        const byTitle = this.sections.slice().sort((a, b) =>
          String(a.name || '').localeCompare(String(b.name || ''), 'uk', {numeric: true, sensitivity: 'base'}));
        const lanes = byTitle.map(section => this.buildLane(
          'section_' + section.id, section.name, section.start_number,
          this.protocols.filter(c => Number(c.sectionid) === Number(section.id))));
        const unassigned = this.protocols.filter(c => !Number(c.sectionid) || !this.sections.some(s => Number(s.id) === Number(c.sectionid)));
        const rest = this.buildLane('none', 'Без відділення', '', unassigned);
        if (rest.total) lanes.push(rest);
        return lanes;
      },
      totals() {
        return this.lanes.reduce((sum, lane) => ({all: sum.all + lane.total, done: sum.done + lane.done}), {all: 0, done: 0});
      },
    },
    methods: {
      hasValue(value) {
        return value !== undefined && value !== null && String(value).trim() !== '';
      },
      buildLane(key, name, start, categories) {
        // порядок категорій у відділенні — як на вкладці "Нумерація"
        const ordered = categories.slice().sort((a, b) => (Number(a.section_position) || 0) - (Number(b.section_position) || 0));
        let fights = [];
        ordered.forEach((c, order) => { fights = fights.concat(this.categoryFights(c, order)); });

        // у послідовності: спершу пронумеровані за номером, далі решта за порядком категорій і колами
        fights.sort((a, b) => {
          const an = Number(a.number), bn = Number(b.number);
          const aHas = a.number !== '' && !isNaN(an), bHas = b.number !== '' && !isNaN(bn);
          if (aHas && bHas && an !== bn) return an - bn;
          if (aHas !== bHas) return aHas ? -1 : 1;
          return a.order - b.order || b.line - a.line || a.index - b.index;
        });

        const real = fights.filter(f => !f.isList);
        const done = real.filter(f => f.winnerId).length;
        const next = real.find(f => !f.winnerId && f.blue.id && f.red.id) || null;

        const query = this.search.trim().toLowerCase();
        const visible = fights.filter(f => {
          if (this.filter === 'done' && !f.winnerId) return false;
          if (this.filter === 'pending' && (f.winnerId || f.isList)) return false;
          if (!query) return true;
          return [f.number, f.categoryName, f.blue.name, f.red.name, f.blue.club, f.red.club].join(' ').toLowerCase().includes(query);
        });

        return {key, name, start, total: real.length, done, next, visible};
      },

      // поєдинок L_(2k) / L_(2k+1): номер, рішення і переможець лежать на позиції (L−1)_k
      categoryFights(c, order) {
        const base = {categoryId: c.id, categoryName: c.fullname || c.name, order};
        const count = this.sportsmanCount(c);
        if (!count) return [];
        if (c.show_type != 1) {
          return [{...base, key: 'list_' + c.id, isList: true, count, number: '', line: 0, index: 0, blue: {}, red: {}}];
        }

        const drawdata = Array.isArray(c.drawdata) ? c.drawdata : [];
        const byPosition = {};
        drawdata.forEach(d => { if (d && d.position !== undefined) byPosition[d.position] = d; });
        const sportsmans = Array.isArray(c.sportsmans) ? c.sportsmans : Object.values(c.sportsmans || {});
        const spId = d => (d && d.sp_id && d.sp_id != 0 ? Number(d.sp_id) : 0);

        const firstLine = this.firstLine(count);
        const fights = [];
        for (let line = firstLine; line >= 1; line--) {
          for (let k = 0; k < Math.pow(2, line - 1); k++) {
            const blue = this.side(byPosition, sportsmans, line, 2 * k, firstLine);
            const red = this.side(byPosition, sportsmans, line, 2 * k + 1, firstLine);
            const result = byPosition[(line - 1) + '_' + k] || {};
            const number = this.hasValue(result.number) ? String(result.number) : '';
            // пропускаємо: прохід без суперника в першому колі та порожні слоти
            if (line === firstLine && (!blue.id || !red.id)) continue;
            if (!number && !blue.id && !red.id) continue;
            fights.push({
              ...base,
              key: c.id + '_' + line + '_' + k,
              line, index: k,
              round: ROUND_LABELS[line] || ('1/' + Math.pow(2, line - 1)),
              number,
              decision: result.decision || '',
              winnerId: spId(result) && (spId(result) === blue.id || spId(result) === red.id) ? spId(result) : 0,
              blue, red,
            });
          }
        }
        return fights;
      },

      side(byPosition, sportsmans, line, index, firstLine) {
        const d = byPosition[line + '_' + index];
        const id = d && d.sp_id && d.sp_id != 0 ? Number(d.sp_id) : 0;
        if (id) {
          const sp = sportsmans.find(s => Number(s.id) === id) || {};
          const oblast = d.oblast || sp.oblast || '';
          const organization = d.organization || sp.organization || '';
          return {id, name: d.name || sp.name, points: d.points, club: [oblast, organization].filter(Boolean).join(' / ')};
        }
        // хто прийде в цей слот: переможець поєдинку, номер якого лежить на цій позиції
        let placeholder = 'очікується';
        if (line < firstLine && d && this.hasValue(d.number)) placeholder = 'Переможець № ' + d.number;
        return {id: 0, name: '', points: '', club: '', placeholder};
      },

      sportsmanCount(c) {
        const list = c.sportsmans ? Object.keys(c.sportsmans).length : 0;
        return list || Number(c.count_sportsmans || c.count || 0);
      },

      // розмір сітки — як у UserBracketsContructor.initCategory
      firstLine(count) {
        let size = 2;
        while (size < count && size < 64) size *= 2;
        return Math.log2(size);
      },

      categoryLink(categoryId) {
        return {path: `/user/tournaments/overview/${this.item ? this.item.id : ''}/bracket/${categoryId}`, query: {tab: 'drawing'}};
      },
    },
  }
</script>

<style scoped>
.tab-fights {
  font-family: var(--tkd-font);
  color: var(--tkd-text);
}

.fg-head-tools {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.fg-search { width: 240px; max-width: 100%; }

.fg-hint { font-size: 13px; }

.fg-lanes {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding-bottom: 12px;
  overflow-x: auto;
  scrollbar-width: thin;
}

.fg-lane {
  /* без внутрішньої прокрутки — колонка росте донизу на всі поєдинки */
  flex: 1 0 300px;
  display: flex;
  flex-direction: column;
  background: var(--tkd-surface);
  border: 1px solid var(--tkd-border);
  border-radius: var(--tkd-radius-lg);
  box-shadow: var(--tkd-shadow);
  overflow: hidden;
}

.fg-lane-head {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px 12px;
  background: var(--tkd-navy);
  color: #fff;
  /* прапор-смужка */
  box-shadow: inset 0 -3px 0 var(--tkd-yellow);
}

.fg-lane-title {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

.fg-lane-name {
  font-size: 16px;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.fg-lane-start {
  flex-shrink: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.fg-lane-progress {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
}

.fg-bar {
  flex: 1;
  height: 5px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  overflow: hidden;
}

.fg-bar span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--tkd-yellow);
}

.fg-lane-next {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  overflow-wrap: anywhere;
}

.fg-lane-next b { color: var(--tkd-yellow); }

.fg-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 10px;
  list-style: none;
}

.fg-fight {
  padding: 8px 10px;
  border: 1px solid var(--tkd-border);
  border-radius: var(--tkd-radius);
  background: var(--tkd-surface);
}

.fg-fight.is-done { background: var(--tkd-bg); }

.fg-fight.is-next {
  border-color: var(--tkd-blue);
  box-shadow: 0 0 0 3px rgba(0, 87, 183, 0.12);
}

.fg-fight-top {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.fg-num {
  flex-shrink: 0;
  min-width: 46px;
  padding: 1px 6px;
  border-radius: 6px;
  background: var(--tkd-navy);
  font-size: 12px;
  font-weight: 800;
  text-align: center;
  color: #fff;
}

.fg-fight.is-next .fg-num { background: var(--tkd-blue); }

.fg-cat {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--tkd-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fg-cat:hover { color: var(--tkd-blue); text-decoration: underline; }

.fg-cat:focus-visible {
  outline: 2px solid var(--tkd-blue);
  outline-offset: 2px;
  border-radius: 4px;
}

.fg-round { flex-shrink: 0; }

.fg-side {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 6px;
  border-radius: 6px;
}

.fg-corner {
  flex-shrink: 0;
  align-self: stretch;
  width: 3px;
  border-radius: 2px;
  background: #0057b7;
}

.fg-side.red .fg-corner { background: #d92d20; }

.fg-name {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.fg-name small {
  font-size: 11px;
  font-weight: 400;
  color: var(--tkd-muted);
}

.fg-name em {
  font-style: italic;
  font-weight: 400;
  color: var(--tkd-muted);
}

.fg-points {
  flex-shrink: 0;
  min-width: 26px;
  padding: 0 6px;
  border-radius: 6px;
  background: var(--tkd-bg);
  font-size: 14px;
  font-weight: 800;
  text-align: center;
}

.fg-side.win { background: rgba(255, 213, 0, 0.2); }
.fg-side.win .fg-name { font-weight: 800; color: var(--tkd-navy); }
.fg-side.win .fg-points { background: var(--tkd-yellow); color: var(--tkd-navy); }
.fg-side.lose .fg-name { color: var(--tkd-muted); }

.fg-win-mark {
  flex-shrink: 0;
  font-size: 14px;
  color: var(--adm-ok-strong);
}

.fg-decision {
  margin-top: 4px;
  text-align: right;
}

.fg-list-note {
  font-size: 12px;
  color: var(--tkd-muted);
}

.fg-empty {
  margin: 0;
  padding: 16px;
  font-size: 13px;
  color: var(--tkd-muted);
  text-align: center;
}

@media (max-width: 767px) {
  .fg-lanes { flex-direction: column; overflow-x: visible; }
  .fg-lane { flex-basis: auto; width: 100%; }
  .fg-search { width: 100%; }
}

@media (max-width: 480px) {
  .fg-head-tools { width: 100%; }
}
</style>
